<script>
  // ?id=9921&dnApp=1&dnAppVersion=6.5.5
  // ?id=9921&dnApp=1&dnAppVersion=6.5.5&darkMode=1

import { onMount, onDestroy } from 'svelte';
import { get } from 'svelte/store';

import {
  handleDarkModeSettings,
  darkModeClass,
  marginClass,
 renderDarkMode
  } from "../../scripts/darkMode";

import {
    baseUrl,
    getUrlVars,
    } from "../../scripts/loadExternalData";  

import { burstPostRatio, doPostRatio, getDisplayContext, isPreview, inDNApp, inIframe  } from "../../scripts/helpers.js";

 import SVGViewer, { transformHtmlColorsToDarkMode } from "./components/SVGViewer.svelte";
      


  export const state = {
    title: "",
    introduction: "",
    source: "",
    subtext: "",
    svgSheet: [],
    darkMode: false,
    adaptedForDarkMode: false,
    darkModeSettings: "no_settings",
    expandableHeight: 0,
    aniPop: "true"
  };
  
  let thesvg = {image:''};

  let currentWidth = 0;

  let turnOffMargins = '';


  let debug = '';

onMount(async () => {

      if (!inIframe()) {
        document.getElementsByTagName("body")[0].style.overflow = "auto";
      } 

    debug = isPreview(); 

    doPostRatio();

  // await waitWithHeightLog();
   //logHeightAsync();

    await fetchPatronData();
    if(state.darkModeSettings === "no_settings"){
      await handleDarkModeSettings('Följ användarens tema');
    } else {

      await handleDarkModeSettings(state.darkModeSettings);
    }

    state.introduction = transformHtmlColorsToDarkMode(state.introduction, get(renderDarkMode));
    state.subtext = transformHtmlColorsToDarkMode(state.subtext, get(renderDarkMode));

    //console.log($renderDarkMode);

    //console.log($darkModeClass);
 

    if(!state.widgetPadding) {
      
      turnOffMargins = 'turnOffMargins';

    }


    updateSvgByWidth(); // första gången



    setTimeout(() => {
      // 🪟 Lyssna på fönsterändringar
      window.addEventListener("resize", handleResize);
    }, 0);



    setTimeout(() => {
      doPostRatio();
    }, 7000);

    setTimeout(() => {
      doPostRatio();
      updateSvgByWidth();
    }, 10000);


    //console.log('burst 1');
    burstPostRatio();
    

});




function handleResize() {
    //console.log("handle rezize");
    doPostRatio();
  // throttla lite (så det inte körs vid varje pixel)
  clearTimeout(handleResize._t);
  handleResize._t = setTimeout(() => {
    updateSvgByWidth();
  }, 200);
}



// 🔁 Funktion som väljer rätt SVG beroende på bredd
function updateSvgByWidth() {
  const dspc = getDisplayContext();
  const width = dspc.width;
  currentWidth = width;

  const items = state.svgSheet;
  let selected = null;

  for (const element of items) {

    const newelement = checkBreakPoint(element);


    if( newelement && width >= parseInt(newelement.Brytpunkt, 10) ) {
          selected = newelement;
    } else {

          break;
    }

  }

  // Bara om det faktiskt är en ny bild
  if (selected && selected.image !== thesvg.image) {
      thesvg = { ...selected }; // ny referens
      //console.log("🖼️ Ny SVG vald pga ändrad bredd:", selected.image);
      //console.log('burst 2');
      burstPostRatio();
  } else {
    //console.log("lilla burst1");
    doPostRatio();
  }
}


onDestroy(() => {
 //  window.removeEventListener("resize", handleResize);
});

function checkBreakPoint(element) {

 let ret = false;

 if (element && typeof element === "object") {

  // console.log('check object');

  if (
    typeof element.Brytpunkt === "string" &&
    element.Brytpunkt.trim().match(/^\d+$/)
  ) {
    // ✅ brytpunkt finns och är numerisk — gå vidare
    ret = element;
  } else if (
    typeof element.bredd === "string" &&
    element.bredd.trim().match(/^\d+$/)
  ) {
    // ✅ brytpunkt saknas, men bredd finns och är numerisk
    element.Brytpunkt = element.bredd;
    ret = element;
  } else {
    // 🚫 inget giltigt värde — avbryt
    ret = false;
  }

} else {
  ret = false;
}

return ret;

}


async function fetchPatronData() {
  const response = await fetch(`${baseUrl}/fields/${getUrlVars().id}`);
  const { fields, title } = await response.json();

  fields.forEach(({ key, value }) => {
    state[key] = value;
  });

}

async function waitWithHeightLog() {
  const endTime = Date.now() + 3000;

  while (Date.now() < endTime) {
    console.log("Body height:", document.body.offsetHeight);
    await new Promise(resolve => setTimeout(resolve, 200));
  }

  console.log("Klar efter 3 sekunder!");
}

function logHeightAsync() {
  (async () => {
    const endTime = Date.now() + 30000;

    while (Date.now() < endTime) {
      console.log("Body size:" +state.title, document.body.offsetWidth + '    ' +document.body.offsetHeight) ;
      console.log("Body size:" +state.title, document.body.clientWidth + '    ' +document.body.clientHeight) ;
 
      await new Promise(resolve => setTimeout(resolve, 200));
    }

    console.log("Klar efter 30 sekunder!");
  })();
}


function initDebugWindow( previewtest ) {
  console.log('debugg');
  const params = new URLSearchParams(window.location.search);

  if (params.get("debugwindow") !== "1") return;

  function bg(el) {
    if (!el) return "—";
    return getComputedStyle(el).backgroundColor;
  }

  const debugEl = document.createElement("div");
  debugEl.style.position = "relative";
  debugEl.style.width= "100%";
  debugEl.style.top= "0px";
  debugEl.style.left = "0px";
  debugEl.style.zIndex = "99999";
  debugEl.style.fontFamily = "monospace";
  debugEl.style.fontSize = "12px";
  debugEl.style.lineHeight = "1.4";
  debugEl.style.background = "rgba(0,0,0,0.85)";
  debugEl.style.color = "#0f0";
  debugEl.style.padding = "12px";
  debugEl.style.borderRadius = "8px";
  debugEl.style.boxShadow = "0 4px 16px rgba(0,0,0,0.4)";
  debugEl.style.boxSizing = "border-box";
  debugEl.style.overflowWrap = "anywhere";
  debugEl.style.wordBreak = "break-word";

  debugEl.innerText = `
DEBUG WINDOW 1.4

Query string:
${window.location.search || "(empty)"}

Background colors:
html : ${bg(document.documentElement)}
body : ${bg(document.body)}
main : ${bg(document.querySelector("main"))}

Body classes:
${classes(document.querySelector("body"))}

Main classes:
${classes(document.querySelector("main"))}

Preview: ${previewtest}
In iframe ${inIframe()}

In DNapp ${inDNApp()}

`.trim();

  document.body.appendChild(debugEl);
}

function classes(el) {
  if (!el || !el.classList || !el.classList.length) return "(inga)";
  return Array.from(el.classList).join(" ");
}


</script>
<main class={`main__content-wrapper ${$marginClass} ${$darkModeClass} ${turnOffMargins}`} style="max-width:{thesvg.Maxbredd || 800}px;">
    {#if state.title}
    <div
      style={state.textMaxWidth
        ? `max-width: ${state.textMaxWidth}px;`
        : "max-width: 560px;"}
      class="standard-title"
    >
      {@html state.title}
    </div>
  {/if}
  {#if state.introduction}
    <div
      style={state.textMaxWidth
        ? `max-width: ${state.textMaxWidth}px;`
        : "max-width: 560px;"}
      class="standard-ingress"
    >
      {@html state.introduction}
    </div>
  {/if}

  {#if state.svgSheet.length}
    {#if thesvg.image.includes(".svg")}
      <div class="bigImageWrapper">
    {#key thesvg.image}
      <SVGViewer
        src={thesvg.image}
        alt={state.title}
        aniPop={state.aniPop}
        class="standard-image"
        darkMode={$renderDarkMode}
      />
    {/key}
      </div>
    {:else if thesvg.image.includes(".png")}
      <div class="bigImageWrapper">
        <img
          src={thesvg.image}
          alt={state.imageAltText || state.title}
          class="standard-image"
        />
      </div>
    {:else if thesvg.image.includes(".jpg")}
      <div class="bigImageWrapper">
        <img
          src={thesvg.image}
          alt={state.imageAltText || state.title}
          class="standard-image"
        />
      </div>
    {:else}
      <div class="bigImageWrapper">
        <img
          src={`local_assets/svgArticle/transpix.png`}
          alt="Illustration"
          class="standard-image"
        />
      </div>
    {/if}
  {/if}


  {#if state.subtext}
      <div       
      style={state.textMaxWidth
        ? `max-width: ${state.textMaxWidth}px;`
        : "max-width: 560px;"} class="standard-subtext standard-ingress">
        {@html state.subtext}
      </div>
  {/if}

  {#if state.source}
      <div       
      style={state.textMaxWidth
        ? `max-width: ${state.textMaxWidth}px;`
        : "max-width: 560px;"} class="standard-source">
        {@html state.source}
      </div>
  {/if}

</main>

<style global type="text/scss" lang="scss">

@font-face {
  font-family: 'DN Sans';
  src:  url("../../assets/fonts/DNSans-1-400-Variable.woff2") format("woff2-variations"),
        url("../../assets/fonts/DNSans-1-400-Variable.woff2") format("woff2");
  font-weight: 300 900;
}
@font-face {
  font-family: 'DN Sans';
  src:  url("../../assets/fonts/DNSansItalic-1-400-Variable.woff2") format("woff2-variations"),
        url("../../assets/fonts/DNSansItalic-1-400-Variable.woff2") format("woff2");
  font-weight: 300 900;
  font-style: italic;
}
@font-face {
  font-family: 'DN Serif Text';
  src:  url("../../assets/fonts/DNSerif-1-600-Variable.woff2") format("woff2-variations"),
        url("../../assets/fonts/DNSerif-1-600-Variable.woff2") format("woff2");
  font-weight: 300 600;
}
@font-face {
  font-family: 'DN Serif Text';
  src: url("../../assets/fonts/DNSerifItalic-1-600-Variable.woff2") format("woff2-variations"),
        url("../../assets/fonts/DNSerifItalic-1-600-Variable.woff2") format("woff2");
  font-weight: 300 900;
  font-style: italic;
}



.standard-title,
.standard-ingress,
.bigImageWrapper,
.standard-subtext,
.standard-source,
.main__content-wrapper  {

  margin-left: auto;
  margin-right: auto;
  width: 100%;

}


.bigImageWrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start

}
.standard-image {
  position: relative;
  width: 100%;
}

.turnOffMargins {

  padding-left: 0;
  padding-right: 0;
  
}

.allways-dark-class {
  background-color: #171717 !important;
}

.main__padded-top-bottom {
  padding-top: 0px;
  padding-bottom: 0px;
}


</style>